import React from "react";
import {
  Upload,
  Form,
  Icon,
  Select,
  Button,
  Radio,
  Input,
  Col,
  DatePicker,
  TimePicker,
  Row, Checkbox,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "../PatientProfileForm/PatientProfileForm.css";
import get from "lodash/get";
import moment from "moment-timezone";
import { getUserTimezone, getUserShortTimezone } from "../../reducers/user/selectors";
import { connect } from "react-redux";

const { Option } = Select;

const fileDummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

class ConsentMevoStep3b extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    moment.tz.setDefault(
      this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
    );
  }

  render() {
    const props = this.props;


    let allowSkipUpload = false;
    let isAfterDeferral = props.consentMethodType.includes('AfterDeferral');
    let isRegainedCapacity = props.consentMethodType.includes('RegainedCapacity');

    if (props.consentMethodType.includes('Paper') && props.skip_upload_allowed_for_types && !props.consent_upload_later){
      if (isAfterDeferral && isRegainedCapacity && props.consentPersonType === "Patient" && props.skip_upload_allowed_for_types.indexOf('consent_patient_regained_capacity_after_deferral_paper') > -1){
        allowSkipUpload = true;
      } else if (isAfterDeferral && props.consentPersonType === "Surrogate" && props.skip_upload_allowed_for_types.indexOf('consent_surrogate_after_deferral_paper') > -1){
        allowSkipUpload = true;
      } else if (isAfterDeferral && props.consentPersonType === "Patient" && props.skip_upload_allowed_for_types.indexOf('consent_participant_after_deferral_paper') > -1){
        allowSkipUpload = true;
      } else if (isRegainedCapacity && props.consentPersonType === "Patient" && props.skip_upload_allowed_for_types.indexOf('consent_regained_capacity_paper') > -1){
        allowSkipUpload = true;
      } else if (props.consentPersonType === "Emergency" && props.skip_upload_allowed_for_types.indexOf('consent_emergency_paper') > -1){
        allowSkipUpload = true;
      } else if (props.consentPersonType === "Surrogate" && props.skip_upload_allowed_for_types.indexOf('consent_surrogate_paper') > -1){
        allowSkipUpload = true;
      } else if (props.consentPersonType === "Patient" && props.skip_upload_allowed_for_types.indexOf('consent_patient_paper') > -1){
        allowSkipUpload = true;
      }
    }

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>
            {props.i18n.t("NamespaceConsentStep3b:Paper Consent Process")}
          </h4>
          <h5>
            {props.i18n.t("Site ID")}: <b>{props.siteID}</b>
          </h5>
          <h5>
            {props.i18n.t("User ID")}: <b>{props.userID}</b>
          </h5>
          <h5>
            {props.i18n.t("Subject ID")}: <b>{props.subjectID}</b>
          </h5>
          <h5>
            {props.i18n.t("Consent Type")}: <b>{props.consentPersonType}</b>
          </h5>
          <h5>
            {props.i18n.t("Consent Method")}: <b>{props.consentMethodType}</b>
          </h5>
        </div>

        <Form.Item>
          {props.form.getFieldDecorator("consentFile", {
            initialValue:
              props.dataset && props.dataset.filename
                ? props.dataset.filename
                : [],
            valuePropName: "fileList",
            getValueFromEvent: props.normFile,
            rules: [
              {
                required: allowSkipUpload ? !props.form.getFieldValue("consent_upload_later") : true,
                message: props.i18n.t(
                  "NamespaceConsentStep3b:Please upload the consent file!"
                ),
              },
            ],
          })(
            <Upload
              id="consentFile"
              name="consentFile"
              customRequest={fileDummyRequest}
              accept=".pdf"
              allowClear
              size="large"
            >
              <Button>
                <Icon type="upload" /> {props.i18n.t("Upload Consent Form")}
              </Button>
            </Upload>
          )}
        </Form.Item>

        {allowSkipUpload && <Form.Item>
            {props.form.getFieldDecorator("consent_upload_later", {
            initialValue: false,
            valuePropName: "checked",
          })(
            <Checkbox onChange={() => { setTimeout(() => {props.form.validateFields()}, 0) }}>
              {this.props.i18n.t(
                "NamespaceConsentStep3aPatient:Upload later"
              )}
            </Checkbox>
          )}
        </Form.Item>}

        <div>

          {props.consentPersonType !== "Emergency" && <Form.Item>
            <label>
              <div className="form-label">
                {props.i18n.t(
                  "NamespaceConsentStep3b:Please check the appropriate box to indicate your decision"
                )}
                :
              </div>
              {props.form.getFieldDecorator("consent_option", {
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
              })(
                <Radio.Group>
                  <Radio value="stay_in_study">
                    {props.i18n.t(
                      "NamespaceConsentStep3b:I wish to stay in the study."
                    )}
                  </Radio>
                  <br />
                  <Radio value="withdraw_from_study">
                    {props.i18n.t(
                      "NamespaceConsentStep3b:I wish to withdraw from the study"
                    )}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>}

          {props.consentPersonType === "Emergency" && <Form.Item>
            <label>
              <div className="form-label">
                {props.i18n.t(
                  "NamespaceConsentStep3b:Please check the appropriate box to indicate your decision"
                )}
                :
              </div>
              {props.form.getFieldDecorator("consent_option", {
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
              })(
                <Radio.Group>
                  <Radio value="stay_in_study">
                    {props.i18n.t(
                      "NamespaceConsentStep3b:The study physician and independent physician declare that the patient meets criteria for enrolment in the study."
                    )}
                  </Radio>
                  <br />
                  <Radio value="withdraw_from_study">
                    {props.i18n.t(
                      "NamespaceConsentStep3b:The study physician and independent physician declare that the patient DOES NOT meet criteria for enrolment in the study."
                    )}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>}

          <Row gutter={8}>
            <Col md={24}>
              <label style={{ display: "block", textAlign: "left" }}>
                {this.props.i18n.t("Date and time*")}
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px",
                }}
              >
                <Form.Item>
                  <div style={{ width: "150px" }}>
                    {props.form.getFieldDecorator("consent_date_date", {
                      rules: [{ required: true, message: "Required" }],
                    })(
                      <DatePicker
                        format="YYYY/MM/DD"
                        placeholder="yyyy-mm-dd"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
                &nbsp;&nbsp;
                <Form.Item>
                  <div style={{ width: "120px" }}>
                    {props.form.getFieldDecorator("consent_date_time", {
                      rules: [{ required: true, message: "Required" }],
                    })(
                      <TimePicker
                        format="HH:mm"
                        placeholder="HH:mm"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
                &nbsp;&nbsp;&nbsp;
                <Form.Item>
                  {this.props.userShortTimezone ||
                    get(this.props, "site.time_zone") ||
                    "UTC"}
                </Form.Item>
              </div>
            </Col>
          </Row>
        </div>

        <div>
          <Form.Item>
            {props.form.getFieldDecorator("email_consent_copy_to_subject", {
              initialValue: false,
              valuePropName: "checked",
            })(
              <Checkbox>
                {this.props.i18n.t(
                  "NamespaceConsentStep3aPatient:Send copy of consent via email"
                )}
              </Checkbox>
            )}
          </Form.Item>

          {props.form.getFieldValue("email_consent_copy_to_subject") && <div>
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t(
                    "NamespaceConsentStep3aPatient:Patient Email"
                  )}
                </div>
                {props.form.getFieldDecorator("consent_subject_email", {
                  initialValue: props.consent_subject_email,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceConsentStep3aPatient:Please enter the participant's email"
                      ),
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t("email")}
                  />
                )}
              </label>
            </Form.Item>
          </div>}
        </div>

        <Form.Item>
          <label>
            <div className="form-label">
              {props.i18n.t(
                "NamespaceConsentStep3b:Please CONFIRM that the data entered above is correct and complete! If no, please click on the Back button!"
              )}
            </div>
            {props.form.getFieldDecorator("consent_provided", {
              initialValue: props.consent_provided,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsentStep3b:Please CONFIRM that the data entered above is correct and complete!"
                  ),
                },
              ],
            })(
              <Select>
                <Option value="yes">{props.i18n.t("Yes")}</Option>
                <Option value="">{props.i18n.t("No")}</Option>
              </Select>
            )}
          </label>
        </Form.Item>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

export default withNamespaces()(connect(mapStateToProps)(ConsentMevoStep3b));



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMevo/ConsentMevoStep3b.js